/**
 * Shared cursor position store via window global.
 *
 * Same pattern as sl-website EffectBus (hv3Cursors).
 * Both @affine/component (cursors, grid) and @affine/core (background-arts)
 * need access, so we use a window global to avoid cross-package import issues.
 */
export interface CursorPosition {
  x: number;
  y: number;
  active: boolean;
}

const STORE_KEY = '__slCursorStore';

function getStore(): CursorPosition[] {
  if (typeof window === 'undefined') return [];
  const w = window as unknown as Record<string, unknown>;
  if (!w[STORE_KEY]) {
    w[STORE_KEY] = [];
  }
  return w[STORE_KEY] as CursorPosition[];
}

export const cursorStore = getStore();

export function registerCursor(): CursorPosition {
  const cursor: CursorPosition = { x: -9999, y: -9999, active: false };
  getStore().push(cursor);
  return cursor;
}

export function moveCursorTo(cursor: CursorPosition, x: number, y: number) {
  cursor.x = x;
  cursor.y = y;
  cursor.active = true;
}

export function deactivateCursor(cursor: CursorPosition) {
  cursor.active = false;
  cursor.x = -9999;
  cursor.y = -9999;
}

/** Read the store from any package without importing this module */
export function readCursorStore(): CursorPosition[] {
  return getStore();
}
